import React from "react";
import { Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo, faPencil } from "@fortawesome/free-solid-svg-icons";
import EmptyFeedCard from "../../../../../_uiComponents/EmptyFeedCard";

export default ({
  assessmentKits,
  assesmentKitsLoading,
  onEditAssessmentKitClick,
  onViewAssessmentsClick,
  onViewCandidatesClick,
}) => {
  return (
    <div className="dashboard-component-container mt-4 border border-6 p-3 bg-white dashboard-custom-tabs dashboard-assessment-kit-list-wrapper h-100">
      <div className="d-flex align-items-center justify-content-between">
        <h4>Assessment Kits</h4>
        <button
          onClick={onViewAssessmentsClick}
          className="bg-transparent border-0 fs-14 text-primary font-weight-medium"
        >
          View All
        </button>
      </div>
      <ul className="dashboard-assessment-kit-list">
        {assesmentKitsLoading ? (
          <div className="d-flex justify-content-center align-items-center mt-4">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          <>
            {Array.isArray(assessmentKits) && assessmentKits.length ? (
              <>
                {Array.isArray(assessmentKits) &&
                  assessmentKits.map((item) => (
                    <li className="bg-grey-4 p-3  border border-6 mt-3  mb-2">
                      <div className="left d-flex justify-content-between align-items-center">
                        <div className="d-flex">
                          <div className="comp-logo mr-3">
                            <img
                              src={"./assets/images/dummy.png"}
                              alt="company"
                            />
                          </div>
                          <div className="info">
                            <h4 className="d-inline-block mr-2 text-capitalize mb-1">
                              {item?.title}
                            </h4>
                            <p className="fs-14 text-grey-4">
                              {item?.headline}
                              {item?.company !== null && (
                                <span> @ {item?.company}</span>
                              )}
                            </p>
                          </div>
                        </div>
                        <div className="btn-wrapper text-right d-flex align-items-center">
                          {item?.status === "publish" && (
                            <p
                              className="view-candidate cursor-pointer mr-2 mb-0 fs- mb-xl-0 text-primary font-weight-medium"
                              onClick={() => onViewCandidatesClick(item?.id)}
                            >
                              View Candidates
                            </p>
                          )}
                          <FontAwesomeIcon
                            icon={faPencil}
                            className="text-grey-4 ml-2 cursor-pointer"
                            onClick={(e) => {
                              onEditAssessmentKitClick(item?.id);
                            }}
                          />
                        </div>
                      </div>

                      {item?.status !== "draft" && (
                        <div className="d-flex line-height-14 mt-2">
                          <p className="fs-14 text-grey-4 mb-0">
                            Assigned Candidates:{" "}
                            <span className="text-dark font-weight-medium">
                              {item?.assigned_candidates_count} {"|"}
                            </span>
                          </p>
                          <p className="fs-14 text-grey-4 mb-0 ml-2">
                            {" "}
                            Accepted Candidates:{" "}
                            <span className="text-dark font-weight-medium">
                              {item?.accepted_interview_kits_count} {"|"}
                            </span>
                          </p>
                          <p className="fs-14 text-grey-4 mb-0 ml-2">
                            Submitted Candidates:{" "}
                            <span className="text-dark font-weight-medium">
                              {item?.submitted_interview_kits_count}
                            </span>
                          </p>
                        </div>
                      )}
                      {item?.status === "draft" && (
                        <p className="fs-14 text-grey-4 mb-0 mt-2">
                          Saved in draft
                        </p>
                      )}
                    </li>
                  ))}
              </>
            ) : (
              <EmptyFeedCard
                src="/assets/images/assessment-empty-state.svg"
                message={"No Assessment Kits"}
                description={
                  "Start guiding candidates through their journey by assigning, and evaluating their assessment kits."
                }
                btnText={"Create Assessment Kit"}
                link={"/create-assessment"}
              />
            )}
          </>
        )}
      </ul>
    </div>
  );
};
